import { MapPin, Phone, Mail, Send, AlertCircle } from "lucide-react";

const TAGS = [
  "Registro Legal",
  "Solicitudes de certificación",
  "Consulta de estatus",
  "Documentos y certificados",
  "Soporte general",
  "Otros servicios",
];

const INFO_RECOMENDADA = [
  "Nombre completo",
  "Empresa o razón social",
  "Correo electrónico",
  "Teléfono de contacto",
  "Descripción clara de la solicitud",
  "Número de solicitud o folio, si aplica",
];

export function AyudaContactoTab() {
  return (
    <div className="space-y-4">
      <section className="rounded-lg border-l-4 border-l-primary-strong bg-surface p-5 shadow-card">
        <h2 className="text-base font-semibold text-fg">Contacto institucional NPMX</h2>
        <p className="mt-1 text-sm text-fg-muted">
          A través de esta sección puedes comunicarte con el equipo de NPMX para recibir
          orientación, seguimiento o atención relacionada con los servicios del sistema SICEN.
        </p>
      </section>

      <section className="rounded-lg border-l-4 border-l-primary-strong bg-surface p-5 shadow-card">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-fg-muted">
          1. Medios de contacto disponibles
        </h3>
        <p className="mt-2 text-sm text-fg-muted">
          Puedes comunicarte con NPMX utilizando cualquiera de los siguientes medios
          institucionales:
        </p>
        <div className="mt-4 grid gap-3 sm:grid-cols-3">
          <MedioCard
            icon={<MapPin className="h-5 w-5" />}
            titulo="Ubicación"
            cuerpo={
              <>
                Alborada 124, Núm. interior 903<br />
                Col. Parque del Pedregal, Tlalpan<br />
                Ciudad de México, C.P. 14010
              </>
            }
          />
          <MedioCard
            icon={<Phone className="h-5 w-5" />}
            titulo="Teléfono"
            cuerpo={
              <a className="text-primary-strong hover:underline" href="tel:+525515205386">
                (55) 1520-5386
              </a>
            }
          />
          <MedioCard
            icon={<Mail className="h-5 w-5" />}
            titulo="Correo electrónico"
            cuerpo={
              <a className="text-primary-strong hover:underline" href="mailto:contacto@npmx.org">
                contacto@npmx.org
              </a>
            }
          />
        </div>
        <div className="mt-4 flex flex-wrap gap-2">
          <a
            href="mailto:contacto@npmx.org"
            className="inline-flex items-center gap-1 rounded bg-primary px-3 py-2 text-sm font-medium text-white hover:opacity-90"
          >
            <Send className="h-4 w-4" /> Enviar correo
          </a>
          <a
            href="tel:+525515205386"
            className="inline-flex items-center gap-1 rounded border border-primary-strong px-3 py-2 text-sm font-medium text-primary-strong hover:bg-estado-info-bg"
          >
            <Phone className="h-4 w-4" /> Llamar
          </a>
        </div>
      </section>

      <section className="rounded-lg border-l-4 border-l-primary-strong bg-surface p-5 shadow-card">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-fg-muted">
          2. ¿Para qué puedes contactarnos?
        </h3>
        <p className="mt-2 text-sm text-fg-muted">
          Los medios de contacto pueden ser utilizados para atender diferentes necesidades
          dentro del portal SICEN:
        </p>
        <div className="mt-3 flex flex-wrap gap-2">
          {TAGS.map((t) => (
            <span
              key={t}
              className="rounded-full bg-estado-info-bg px-3 py-1 text-xs font-medium text-estado-info"
            >
              {t}
            </span>
          ))}
        </div>
        <div className="mt-4 flex items-start gap-2 rounded border border-estado-warn/25 bg-estado-warn-bg p-3 text-xs text-estado-warn">
          <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
          <span>
            Se recomienda indicar claramente el motivo del contacto para facilitar la
            canalización de tu solicitud.
          </span>
        </div>
      </section>

      <section className="rounded-lg border-l-4 border-l-primary-strong bg-surface p-5 shadow-card">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-fg-muted">
          3. Información recomendada
        </h3>
        <p className="mt-2 text-sm text-fg-muted">
          Para agilizar la atención, es recomendable incluir la siguiente información:
        </p>
        <ul className="mt-3 grid gap-1 sm:grid-cols-2">
          {INFO_RECOMENDADA.map((x) => (
            <li key={x} className="flex items-center gap-2 text-sm text-fg-muted">
              <span className="h-1.5 w-1.5 rounded-full bg-primary" /> {x}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

function MedioCard({
  icon, titulo, cuerpo,
}: {
  icon: React.ReactNode;
  titulo: string;
  cuerpo: React.ReactNode;
}) {
  return (
    <div className="rounded-lg border bg-surface-2/40 p-4 text-center transition hover:border-primary-strong hover:bg-estado-info-bg/40">
      <div className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-primary-tint text-primary-strong">
        {icon}
      </div>
      <h4 className="mt-2 text-sm font-semibold text-fg">{titulo}</h4>
      <div className="mt-1 text-xs leading-relaxed text-fg-muted">{cuerpo}</div>
    </div>
  );
}
